import {
  CHANGE_LANGUAGE,
  RESET_STATE,
  SET_COORDS,
  SET_GEOLOCATION,
  SET_PERSISTENCE,
  SET_REPORT_URL,
  SET_THEME_MODE,
  SET_VIN,
  SET_REGISTERED_TRANSACTION,
  SET_USER_DATA,
  SET_SEARCH_ID
} from "./actionTypes";

const handlePersistence = (stateToStringify) => {
  localStorage.setItem('state', JSON.stringify(stateToStringify));
}

const AppReducer = (state, action) => {
  switch (action.type) {
    case SET_PERSISTENCE:
      return action.payload
    case RESET_STATE:
      handlePersistence(action.payload)
      return action.payload
    case CHANGE_LANGUAGE:
      const languagePayload = {
        ...state,
        language: action.payload
      }
      handlePersistence(languagePayload)
      return languagePayload
    case SET_THEME_MODE:
      const themeModePayload = {
        ...state,
        themeMode: action.payload
      }
      handlePersistence(themeModePayload)
    case SET_GEOLOCATION:
      const geolocationPayload = {
        ...state,
        geolocation: action.payload
      }
      handlePersistence(geolocationPayload)
      return geolocationPayload
    case SET_COORDS:
      const coordsPayload = {
        ...state,
        coords: action.payload
      }
      handlePersistence(coordsPayload)
      return coordsPayload
    case SET_VIN:
      const vinPayload = {
        ...state,
        vin: action.payload
      }
      handlePersistence(vinPayload)
      return vinPayload
    case SET_REPORT_URL:
      const reportUrlPayload = {
        ...state,
        reportUrl: action.payload
      }
      handlePersistence(reportUrlPayload)
      return reportUrlPayload
    case SET_REGISTERED_TRANSACTION:
      const registeredTransactionPayload = {
        ...state,
        registeredTransaction: action.payload
      }
      handlePersistence(registeredTransactionPayload)
      return registeredTransactionPayload
    case SET_USER_DATA:
      const userDataPayload = {
        ...state,
        userData: action.payload
      }
      handlePersistence(userDataPayload)
      return userDataPayload
    case SET_SEARCH_ID:
      const searchIdPayload = {
        ...state,
        searchId: action.payload
      }
      handlePersistence(searchIdPayload)
      return searchIdPayload
    default:
      return state;
  }
};

export default AppReducer;
